
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/instituto-realizar",
      function () {
        return require("private-next-pages/instituto-realizar/index.js");
      }
    ]);
  